import { CompanyMenuItem, ICompanyMenuItem } from "ui/Scripts/source/models/company/companyMenuItem";
import { IRiskPageData, RiskPageData } from "./riskPageData";
import { ISavedListFilter, SavedListFilter } from "../common/savedListFilter";
import { SavedChartPanel } from "../chart/savedChartPanel";
import { Base } from "ui/Scripts/source/framework/base";

export interface IRiskPage extends IRiskPageData {
    //panels: IPagePanel[];
    companies: ICompanyMenuItem[];
    companyFilters: ISavedListFilter[];
    userFilters: ISavedListFilter[];
    showDocumentPreview: boolean;
    riskProcessName: string;
}

export class RiskPage extends RiskPageData implements IRiskPage {
    //panels: EventPagePanel[];
    chartPanels: SavedChartPanel[];
    companies: CompanyMenuItem[];
    companyFilters: SavedListFilter[];
    userFilters: SavedListFilter[];
    showDocumentPreview: boolean;
    riskProcessName: string;

    constructor();
    constructor(obj: IRiskPage);
    constructor(obj?: any) {
        super(obj);
        //this.panels = Base.getTypedArray(obj ? obj.panels : null, EventPagePanel);
        this.chartPanels = Base.getTypedArray(obj ? obj.chartPanels : null, SavedChartPanel);
        this.companies = Base.getTypedArray(obj ? obj.companies : null, CompanyMenuItem);
        this.companyFilters = Base.getTypedArray(obj ? obj.companyFilters : null, SavedListFilter);
        this.userFilters = Base.getTypedArray(obj ? obj.userFilters : null, SavedListFilter);
        this.showDocumentPreview = obj && obj.showDocumentPreview || false;
        this.riskProcessName = obj && obj.riskProcessName || "";
    }
}
